export const nintendo_company_ndid = '297eb6e42dfdb897012dfdbd5de50004';
export const ncl_company_ndid = '8af581c62c63c18a012c63cb00dd000e';
